import styled from 'styled-components';
import { borderRadius, colorUsage, getSpacing, transitionDuration } from 'stylesheet';
import { Drag } from 'theme/icons';
import { DropzoneStatus } from './type';
import { getBorderColorFromStatus } from './util';
var DROPZONE_CONTAINER_WIDTH = 400;
var DROPZONE_CONTAINER_HEIGHT = 90;
var DropzoneContainer = styled.div.withConfig({
  displayName: "ImageDropzonestyle__DropzoneContainer",
  componentId: "sc-fx6qli-0"
})(["display:flex;flex:1;flex-direction:column;align-items:center;justify-content:center;width:", "px;min-height:", "px;margin:", " auto;color:", ";text-align:center;background-color:", ";border-color:", ";border-style:dashed;border-width:2px;border-radius:", ";outline:none;transition:border ", " ease-in-out;&:hover{cursor:pointer;}&:focus{border-color:", ";}"], DROPZONE_CONTAINER_WIDTH, function (props) {
  return props.ratio !== undefined ? DROPZONE_CONTAINER_WIDTH / props.ratio : DROPZONE_CONTAINER_HEIGHT;
}, getSpacing(3), colorUsage.dropzone.base.color, colorUsage.dropzone.base.backgroundColor, function (props) {
  return getBorderColorFromStatus(props.status);
}, borderRadius.medium, transitionDuration["default"], getBorderColorFromStatus(DropzoneStatus.ACTIVE));
var DragIcon = styled(Drag).withConfig({
  displayName: "ImageDropzonestyle__DragIcon",
  componentId: "sc-fx6qli-1"
})(["margin:", " 0;path{fill:", ";}"], getSpacing(2), colorUsage.dropzone.base.color);
var ErrorMessage = styled.div.withConfig({
  displayName: "ImageDropzonestyle__ErrorMessage",
  componentId: "sc-fx6qli-2"
})(["margin-bottom:", ";color:", ";"], getSpacing(2), colorUsage.message.error);
export { DropzoneContainer, DragIcon, ErrorMessage };